import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { axiosPath, path } from '../../../routing/helpers/router';
import * as moduleAction from '../../../store/actions/moduleAction';
import { AppNoInfo } from '@/layout/AppComponents';

export default function ModuleDocumentManagerCoverRedirectScreen() {
  const { moduleBridgeHex } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const permissionsLevel = useSelector(
      (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level,
    );

  // > LOAD MODULE DATA //
    const loadModuleData = useCallback(async () => {
      dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_documentManager_getModuleData'),
          'moduleData',
          {
            moduleBridgeHex,
          },
        ),
      );
    }, []);
  
    useEffect(() => {
      loadModuleData();
    }, []);
    // > LOAD MODULE DATA //
  
    // < STORE CALLS
    const loadModulePermissions = useCallback(async () => {
      try {
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_documentManager_getPermissions'),
            'permissions',
            {
              moduleBridgeHex,
              subType: 'permissions',
            },
          ),
        );
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_documentManager_getPermissions'),
            'userBridge',
            {
              moduleBridgeHex,
              subType: 'userBridge',
            },
          ),
        );
      } catch (err) {}
    }, [moduleBridgeHex]);
  
    useEffect(() => {
      loadModulePermissions();
    }, [moduleBridgeHex]);
    // < STORE CALLS

  useEffect(() => {
    if (permissionsLevel !== undefined) {
        navigate(
            path({
                name: permissionsLevel === 1
                    ? 'user_module_documentManager_cover'
                    : 'user_module_documentManager_item_list',
                params: {
                    moduleBridgeHex,
                },
            })
        );
    }
    
  }, [permissionsLevel]);

  return <AppNoInfo />;
}
